import React, { useEffect } from "react";
import Header from "../components/Header";
import MenuPreview from "../components/MenuPreview";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import { SiteContentProvider } from "../data/SiteContentContext";

export default function Menu() {
  // Land at the top on navigation so the header doesn't overlap the section title.
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <SiteContentProvider>
      <div className="bg-white text-[#0B0B0B] min-h-screen">
        <Header />
        <main className="pt-20 sm:pt-24" data-testid="menu-page">
          <MenuPreview />
        </main>
        <Footer />
        <BackToTop />
      </div>
    </SiteContentProvider>
  );
}
